import { render, staticRenderFns } from "./CargoCrudStatusInTraffic.vue?vue&type=template&id=cc23832a"
import script from "./CargoCrudStatusInTraffic.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusInTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports